import "bootstrap/dist/css/bootstrap.min.css";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import '../../DataTableDemo.css';
import useParamsElectronicPayroll from '../../helpers/useParamsElectronicPayroll';
import dateFormat from '../../services/DateFormat.service';
import './HistoricElectronicPayroll.css';
import Video from '../Video/Video';
import { Label } from './HistoricElectronicPayroll.styles';
import ConfBar from "../ConfBar/ConfBar";
import useParamsSilog from "../../helpers/useParamsSilog";
import { tableDate, timeToDate } from "../../services/tableDate.service";
import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { excelReport } from "../../services/excelReport.service";
import { excelExport } from "../../services/excelExport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ElectronicPayroll
Description : Consulta de nómina electrónica
Date Autor Modification
================================================================================
28/03/2022 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente y sus funciones.
================================================================================ */


export default function HistoricElectronicPayroll() {

  /*Propiedades del componente*/
  const [anio, setAnio] = useState("");
  const [mes, setMes] = useState("");
  const [consultado, setConsultado] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [PDF, setPDF] = useState("");
  const [contrato, setContrato] = useState("");
  const [prefijo, setPrefijo] = useState("");
  const [numeroDian, setNumeroDian] = useState("");

  /*Constantes globales para el componente*/
  const [nomina, setNomina] = useState([])
  const [params] = useParamsElectronicPayroll();
  const [planoSilog, setPlanoSilog] = useState([])
  const [paramsSilog] = useParamsSilog()

  const [isOpenNE, setIsOpenNE] = React.useState(false);
  const [isOpenPDF, setIsOpenPDF] = React.useState(false);
  const [isOpenSilog, setIsOpenSilog] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);

  const [rowState, setRowState] = useState([]);

  const elementWidth = { width: "20rem", justifySelf: "center" }
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const toast = useRef(null);

  useEffect(() => {
    const validateDian = async () => {
      await apis.validateDIANProcess(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        console.log(res.data)
      }).catch(res => {
        toast.current.show({
          severity: 'warn', summary: 'Aviso', detail: (
            <div className="flex flex-column" style={{ flex: '1' }}>
              {res.response.data.message} <Link to='/ProcessDIAN'>Hazlo aquí</Link>
            </div>), sticky: true
        });
      })
    }
    validateDian()
  }, []);

  useEffect(() => {
    /*Se incializan las propiedades del componente*/
    const payrollTemplate = async () => {
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setNomina(plantilla)
    }
    payrollTemplate()
  }, [params]);

  useEffect(() => {
    const plainTemplate = async () => {
      /*Se incializan las propiedades del componente*/
      if (localStorage.getItem('facturaTech') === 'N') {
        let plantilla = []
        paramsSilog.forEach((p, index) => {
          if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
            plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
          else {
            plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
        })
        console.log(plantilla)
        setPlanoSilog(plantilla)
      }
    }
    plainTemplate()
  }, [paramsSilog]);

  const showModalNE = () => {
    setIsOpenNE(true);
  };

  const hideModalNE = () => {
    setIsOpenNE(false);
  };

  const showModalPDF = () => {
    setIsOpenPDF(true);
  };

  const hideModalPDF = () => {
    setIsOpenPDF(false);
  };

  const showModalSilog = () => {
    setIsOpenSilog(true);
  };

  const hideModalSilog = () => {
    setIsOpenSilog(false);
  };

  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        {localStorage.getItem("facturaTech") === "N" && <Button label="Plano SilogTran" loading={loading7} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading7(true); showModalSilog() }} />}
        <Button icon="pi pi-file-excel" label="Configuración NE" loading={loading1} className="p-button-success mr-2 p-button-sm"
          tooltip="Configuración nómina electrónica" tooltipOptions={{ position: 'top' }} onClick={() => { setLoading1(true); postConfReport() }} />
        <Button label="Reporte nómina electrónica" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm"
          onClick={() => showModalNE()} />
      </React.Fragment>
    )
  }


  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <InputText type="number" min={0} style={{ width: "6rem", marginRight: "0.5rem" }} placeholder="Año*" onChange={(e) => { setAnio(e.target.value) }} />
        <InputText type="number" min={0} max={12} style={{ width: "5rem", marginRight: "0.5rem" }} placeholder="Mes" onChange={(e) => { setMes(e.target.value) }} />
        <Button label="Consultar" icon="pi pi-search" disabled={anio.length !== 4} loading={loading2} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading2(true); setTabla() }} />
        <Button type="button" disabled={!consultado} tooltip="Exportar resultados consulta" tooltipOptions={{ position: 'top' }} icon="pi pi-file-excel" label="Exportar"
          loading={loading3} onClick={() => { setLoading3(true); exportExcel() }} className="p-button-success mr-2 p-button-sm" />
      </React.Fragment>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{ width: "10rem" }}>
        {rowData['Estado Transferencia'] === "ENVIADO" ?
          <Button icon="pi pi-file-pdf" className="p-button-danger p-button-sm text-xs ml-1" tooltip="Consultar PDF" tooltipOptions={{ position: 'top' }}
            loading={rowState[rowData.rowId]} onClick={() => { setRowState({ ...rowState, [rowData.rowId]: true }); getPDF(rowData.rowId, rowData.ID, rowData.CONTRACT, rowData.PREFIX, rowData.NRO_DOC_DIAN) }}
          />
          : null
        }
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Contrato': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Identificación': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CUNE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nro Documento Dian': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Consecutivo novedad': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Prefijo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CREATION_USER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CREATION_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Estado Transferencia': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Fecha Transferencia': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Mes': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Año': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _anio = anio
    let _mes = mes

    if (_mes === "") {
      _mes = "NULL"
    }

    try {
      await apis.getReadDataElectronicPayroll(_entity, _cliente, _anio, _mes, headers).then(res => {
        if (res.data["DATA_NE"].length > 0) {
          let data = res.data["DATA_NE"]
          let rows = []
          let states = {}
          let rowCounter = 0
          data.forEach(element => {
            let fechaCreacion = tableDate(element.CREATION_DATE)
            let fechaTransferencia = tableDate(element.TRANSFER_DATE)
            let row = {
              rowId: rowCounter,
              ID: element.ID,
              CREATION_USER: element.CREATION_USER,
              Contrato: element.CONTRACT,
              'Identificación': element.NUMBER_ID,
              Nombre: element.NAME,
              'Año': element.YEAR,
              Mes: element.MONTH,
              CUNE: element.CUNE,
              Prefijo: element.PREFIX,
              'Nro Documento Dian': element.NRO_DOC_DIAN,
              'Consecutivo novedad': element.DOCU_DIAN,
              CREATION_DATE: fechaCreacion,
              'Fecha Transferencia': fechaTransferencia,
              'Estado Transferencia': element.STATUS_TRANSFER,
            }
            states = {
              ...states,
              [rowCounter]: false
            }
            rows.push(row)
            rowCounter++
          })
          setRowState(states)
          setRows(rows)
          setRowData(rows)
          setConsultado(true)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa' });
        }
        else {
          setRows([])
          setRowData([])
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Consulta sin resultados' });
        }
        setLoading2(false)
      })
    }
    catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postElectronicPayrollReport() {
    /*Función encargada de generar la información de un reporte de nómina electrónica*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    nomina.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }
    console.log(report)
    nomina.forEach(c => {
      c.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
      })
    })
    try {
      await apis.postReportElectronicPayroll(report, headers).then(res => {
        finalReport = res.data
        try {
          excelReport(finalReport, 'reporteNóminaElectrónica')
          setLoading5(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de nómina electrónica generado existosamente" });
          hideModalNE();
        }
        catch (err) {
          setLoading5(false)
          console.error(err.message);
        }
      })
    }
    catch (err) {
      console.log(err)
      setLoading5(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postConfReport() {
    /*Función encargada de cargar la informacion del reporte de configuración*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    const params = [
      {
        PARAMETERS: [
          { LABEL: "pinEntity", VALUE: localStorage.getItem("entity") },
          { LABEL: "pinClient", VALUE: localStorage.getItem("client") }
        ]
      }
    ]
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: params
    }
    try {
      await apis.electronicPayrollConf(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteConfiguracionNE")
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de configuración generado existosamente" });
      })
    }
    catch (err) {
      console.log(err)
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function plainSilog() {
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: [{ PARAMETERS: [] }]
    }
    let max = 0
    planoSilog.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({})
    }
    console.log(report)
    planoSilog.forEach(c => {
      c.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
      })
    })
    try {
      await apis.plainFileSilog(report, headers).then(res => {
        finalReport = res.data
        try {
          excelReport(finalReport, 'planoSilogTran')
          setLoading7(false)
          setLoading8(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano SilogTran generado existosamente" });
          hideModalSilog();
        }
        catch (err) {
          setLoading7(false)
          setLoading8(false)
          console.error(err.message);
        }
      })
    }
    catch (err) {
      console.log(err)
      setLoading7(false)
      setLoading8(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const exportExcel = () => {
    let _rows = []
    console.log(rows)
    rows.forEach(element => {
      let row = element
      delete row.rowId
      row["Fecha Transferencia"] = timeToDate(row["Fecha Transferencia"])
      row["CREATION_DATE"] = timeToDate(row["CREATION_DATE"])
      _rows.push(row)
    })
    excelExport(_rows, 'NóminaElectrónica');
    setLoading3(false);
  }
  
  async function getPDF(id, register, contract, prefix, dian) {
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    try {
      await apis.getPDFFile(entity, client, register, headers).then(res => {
        if (res.data.PDF) {
          const pdf = res.data.PDF.DATA
          const tipo = res.data.PDF_OUTPUT
          setPDF({ FILE: pdf, PDF_OUTPUT: tipo })
          setContrato(contract)
          setPrefijo(prefix)
          setNumeroDian(dian)
          showModalPDF()
        }
        else {
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'No hay documento disponible', sticky: true });
        }
      })
      setRowState({ ...rowState, [id]: false })
    }
    catch (err) {
      setRowState({ ...rowState, [id]: false })
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  /*Headers y footers de los modales del componente*/
  const footerNE = (
    <div>
      <Button label="Generar" loading={loading5} onClick={() => { setLoading5(true); postElectronicPayrollReport() }} />
    </div>
  );

  const headerNE = (
    <div>
      <h3>Parámetros reporte de nómina electrónica</h3>
    </div>
  )

  const footerSilog = (
    <div>
      <Button label="Generar" loading={loading8} onClick={() => { setLoading8(true); plainSilog() }} />
    </div>
  );

  const headerSilog = (
    <div>
      <h3>Parámetros plano SilogTran</h3>
    </div>
  )

  const footerPDF = (
    <div>
      {PDF.PDF_OUTPUT === '1' ?
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + PDF.FILE} downloadName={"Documento_" + localStorage.getItem("client") + "_" + contrato + "_" + prefijo + "_" + numeroDian} onDownloadSuccess={() => { hideModalPDF(); setLoading6(false); }}>
          <Button icon="pi pi-file-pdf" className="p-button-danger p-button-sm text-xs" label="Descargar" loading={loading6} onClick={() => setLoading6(true)} />
        </Base64Downloader>
        :
        <Button icon="pi pi-arrow-down" onClick={() => { window.open(PDF.FILE, "_blank"); hideModalPDF() }} />
      }
    </div>
  );

  const headerPDF = (
    <div>
      <h3>Descargar PDF</h3>
    </div>
  );

  /*Funciones que manejan los eventos que cambian los campos de entrada del componente*/
  function handleChange(e, d, index) {
    //console.log(e.value)
    setNomina(n => {
      let newNomina = [...n]
      console.log(index)
      console.log(n)
      newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeDate(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setNomina(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeText(e, d, index) {
    setNomina(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  function handleChangeSilog(e, d, index) {
    //console.log(e.value)
    setPlanoSilog(n => {
      let newNomina = [...n]
      console.log(index)
      console.log(n)
      newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeDateSilog(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setPlanoSilog(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeTextSilog(e, d, index) {
    setPlanoSilog(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  const rowClassName = (rowData) => {
    return { 'error-row': (rowData["STATUS"] === "ERROR") };
  }

  const createDateTemplate = (rowData) => {
    const date = timeToDate(rowData.CREATION_DATE);
    return date
  }

  const transferDateTemplate = (rowData) => {
    const date = timeToDate(rowData["Fecha Transferencia"]);
    return date
  }

  /*Renderizado del componente*/
  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={headerNE} footer={footerNE} visible={isOpenNE} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalNE}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los campos de entrada del modal del componente*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && nomina.length > 0 && typeof nomina[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={nomina[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                      placeholder={nomina[index]["NAME"] ? nomina[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChange(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <Calendar key={d} style={elementWidth} id="navigators" value={nomina[index].CODE}
                      onChange={(e) => handleChangeDate(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder={nomina[index].CODE}
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={nomina[index]}
                      onChange={(e) => handleChangeText(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>
        {localStorage.getItem("facturaTech") === "N" &&
          <Dialog header={headerSilog} footer={footerSilog} visible={isOpenSilog} bo
            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalSilog}>
            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
            {paramsSilog.map((d, index) => {
              /*Generación dinámica de los campos de entrada del modal del componente*/
              if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && planoSilog.length > 0 && typeof planoSilog[index] !== "undefined") {
                let label = d.LABEL;
                if (d.REQUIRED === "1") {
                  label = label + "*"
                }
                switch (d.TYPE) {
                  case "LIST":
                    let options = []
                    if (d.REQUIRED === "1") {
                      options = [...d.OPTIONS]
                    }
                    else {
                      options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                    }
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <Dropdown
                        key={index}
                        style={elementWidth}
                        value={planoSilog[index]["NAME"]}
                        options={options}
                        filter showClear filterBy="NAME"
                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                        placeholder={planoSilog[index]["NAME"] ? planoSilog[index]["NAME"] : "Seleccione"}
                        onChange={(e) => handleChangeSilog(e, d, index)}
                      />
                    </>
                    );
                  case "DATE":
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <Calendar key={d} style={elementWidth} id="navigators" value={planoSilog[index].CODE}
                        onChange={(e) => handleChangeDateSilog(e, d, index)}
                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={planoSilog[index].CODE}
                        yearRange="2010:2030" /></>
                    );
                  case "NUMBER":
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <InputText
                        key={d}
                        style={elementWidth}
                        id="label2"
                        type="text"
                        value={planoSilog[index]["CODE"]}
                        onChange={(e) => handleChangeTextSilog(e, d, index)}
                      /></>
                    )
                  default:
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <InputText
                        key={d}
                        style={elementWidth}
                        id="label2"
                        type="text"
                        value={planoSilog[index]["CODE"]}
                        onChange={(e) => handleChangeTextSilog(e, d, index)}
                      /></>
                    )
                }
              }
            })}
          </Dialog>
        }
        <Dialog header={headerPDF} footer={footerPDF} visible={isOpenPDF} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalPDF}>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Consulta nómina electrónica</span>
          <Video header="Instructivo consultas" url={localStorage.getItem('HISTORICELECTRONICPAYROLL_VIDEO')} />
        </div>
        <div className="flex flex-1 justify-content-center align-items-center">
          <Label htmlFor="label">Campos obligatorios(*)</Label>
        </div>
        <div className="card mt-4">
          <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
          <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            selectionMode="multiple" selection={registros} onSelectionChange={(e) => setRegistros(e.value)} dataKey="ID"
            size="small" filters={filters1} filterDisplay="menu"
            globalFilterFields={['ID', 'Contrato', 'Identificación', 'Nombre', 'CUNE', 'Nro Documento Dian', 'Consecutivo novedad', 'Prefijo', 'CREATION_USER', 'CREATION_DATE', 'Estado Transferencia',
              'Fecha Transferencia', 'Mes', 'Año']}
            header={header1} >
            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
            <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
            <Column field="Contrato" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
            <Column field="Identificación" header="Número de documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
            <Column field="Nombre" header="Nombre" filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
            <Column field="Nro Documento Dian" header="Nro documento DIAN" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Concepto" sortable></Column>
            <Column field="Consecutivo novedad" header="Consecutivo novedad" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consecutivo" sortable></Column>
            <Column field="Prefijo" header="Prefijo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
            <Column field="CREATION_DATE" header="Fecha de creación" body={createDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades" sortable></Column>
            <Column field="Estado Transferencia" header="Estado transferencia" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Base" sortable></Column>
            <Column field="Fecha Transferencia" header="Fecha transferencia" body={transferDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Valor" sortable></Column>
            <Column field="Mes" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consolidado" sortable></Column>
            <Column field="Año" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="CUNE" header="CUNE" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
            <Column header="Acciones" headerStyle={{ width: '10rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "10rem" }} body={actionBodyTemplate} />
          </DataTable>
        </div>
      </div >
    </div >
  );
}